import { BodyExtraSmall, Stepper } from '@taxbit-private/cosmic'
import {
  COSMIC_VALUE_PLACEHOLDER,
  useCosmicLocalizationContext,
} from '@taxbit-private/cosmic-localization'
import { useMemo } from 'react'

type SuccessStateStepperProps = {
  lastSuccessfulUpdate?: string | null
  nextUpdateScheduled?: string | null
}

const SuccessStateStepper = ({
  lastSuccessfulUpdate,
  nextUpdateScheduled,
}: SuccessStateStepperProps) => {
  const { formatDateTime } = useCosmicLocalizationContext()

  const steps = useMemo(
    () => [
      {
        key: 'last-successful-update',
        title: 'Last successful update',
        titleUtilityElement: (
          <BodyExtraSmall colorVariant="secondary">
            {lastSuccessfulUpdate
              ? formatDateTime({
                  date: lastSuccessfulUpdate,
                  format: 'DateTimeShortened',
                  tz: 'Browser',
                })
              : COSMIC_VALUE_PLACEHOLDER}
          </BodyExtraSmall>
        ),
        titleUtilityElementPlacement: 'right' as const,
        content: <></>,
        avatarProps: { iconName: 'check-circle' as const, variant: 'success' as const },
      },
      {
        key: 'next-update-scheduled',
        title: 'Next update scheduled',
        titleUtilityElement: (
          <BodyExtraSmall colorVariant="secondary">
            {nextUpdateScheduled
              ? formatDateTime({
                  date: nextUpdateScheduled,
                  format: 'DateTimeShortened',
                  tz: 'Browser',
                })
              : COSMIC_VALUE_PLACEHOLDER}
          </BodyExtraSmall>
        ),
        titleUtilityElementPlacement: 'right' as const,
        content: <></>,
        avatarProps: { iconName: 'clock' as const, variant: 'secondary' as const },
      },
    ],
    [lastSuccessfulUpdate, nextUpdateScheduled, formatDateTime]
  )

  return <Stepper currentStep={1} steps={steps} />
}

export default SuccessStateStepper
